import useSWR, { SWRConfiguration } from 'swr';
import { usePrivate } from '@/components/private';
import { logError } from '@/lib/logger';

export function useGetPedigreeByEntityGuid(
  entityGuidId?: string,
  maxGeneration?: number,
  swrConfig?: SWRConfiguration,
) {
  const { entityApi } = usePrivate();

  return useSWR(
    entityApi && entityGuidId
      ? ['/api/Entity/apiEntityGetPedigreeGet', entityGuidId, maxGeneration]
      : null,
    () => entityApi?.apiEntityGetPedigreeGet(entityGuidId, maxGeneration),
    {
      onError: (error) => {
        logError(
          '[BREEDLOGIC] <useGetPedigree> Error fetching Pedigree by Guid',
          error,
        );
      },
      revalidateIfStale: true,
      ...swrConfig,
    },
  );
}
